import { render, staticRenderFns } from "./Order_customer_edit.vue?vue&type=template&id=0808c1e0&scoped=true&"
import script from "./Order_customer_edit.vue?vue&type=script&lang=js&"
export * from "./Order_customer_edit.vue?vue&type=script&lang=js&"
import style0 from "./Order_customer_edit.vue?vue&type=style&index=0&id=0808c1e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0808c1e0",
  null
  
)

export default component.exports